import { formatTenths } from '../decimal.ts';

/** English coordinate-plane prompts (ADR 0085 §2, §5). */
export const coordinatePrompts = {
    readPoint: (label: string) => `What are the coordinates of point ${label}?`,
    namePoint: (pair: string) => `Which point is at ${pair}?`,
    distance: (from: string, to: string) => `How far is point ${from} from point ${to}?`,
    quadrant: (label: string) => `Which quadrant is point ${label} in?`,
    /** A negative coordinate prints with an ASCII hyphen (ADR 0070 §2), which String() gives. */
    pair: (x: number, y: number) => `(${x}, ${y})`,
    units: (count: number) => `${count} ${count === 1 ? 'unit' : 'units'}`,
    /** Polygons (ADR 0087 §3, §5). A shape is named by its corners in order. */
    shapeName: (rectangle: boolean, corners: string) => `${rectangle ? 'rectangle' : 'shape'} ${corners}`,
    area: (shape: string) => `What is the area of ${shape}?`,
    perimeter: (shape: string) => `What is the perimeter of ${shape}?`,
    side: (side: string) => `How long is side ${side}?`,
    /** Triangles (ADR 0092 §4). */
    triangleName: (corners: string) => `triangle ${corners}`,
    base: (base: string) => `How long is base ${base}?`,
    /** One triangle to a grid, so the height needs no name but its base's. */
    height: (base: string) => `What is the height to base ${base}?`,
    squareUnits: (count: number) => `${count} ${count === 1 ? 'square unit' : 'square units'}`,
    /** Missing Corner (ADR 0094 §5). Each given corner is its letter and pair: "A (2, 3)". */
    missingCorner: (given: string[], missing: string) =>
        `Rectangle ABCD has corners ${given.slice(0, -1).join(', ')} and ${given[given.length - 1]}. What are the coordinates of ${missing}?`,
    /**
     * Distance Between Points (ADR 0125 §3). The key is the two legs squared and
     * summed, then the distance; `tenths` is the distance in tenths, rounded.
     * "about" because the approximation sign is not WinAnsi (ADR 0070).
     */
    pointDistance: (from: string, to: string) => `How far is point ${from} from point ${to}, to the nearest tenth?`,
    pointDistanceWhole: (horizontal: number, vertical: number, sum: number, distance: number) =>
        `${horizontal}² + ${vertical}² = ${sum}: ${distance} units`,
    pointDistanceRounded: (horizontal: number, vertical: number, sum: number, tenths: number) =>
        `${horizontal}² + ${vertical}² = ${sum}: about ${formatTenths(tenths, '.')} units`,
    /** Slope (ADR 0126 §3, §4). The word beside the blank under a drawn line, and the two-points question. */
    slopeWord: 'slope',
    slopeFromPoints: (first: string, second: string) => `What is the slope of the line through ${first} and ${second}?`,
};
